<template>
  <div class="address">
    <div class="r-text-intro">פרטים אישיים</div>
    <div class="r-text-headline-paragraph">כתובת מלאה</div>

    <div class="r-form">
      <div class="r-form-row">
        <default-autocomplete
          :value="city"
          :options="cities"
          label="יישוב"
          autofocus
          validations="required"
          @observe="observe"
          @input="setAddressCity" />
      </div>

      <div class="row no-wrap q-gutter-sm r-form-row">
        <default-autocomplete
          ref="street"
          :value="street"
          :options="streets"
          label="רחוב"
          class="col-7"
          validations="required"
          @observe="observe"
          @input="setAddressStreet">
        </default-autocomplete>

        <default-text-input
          ref="houseNumber"
          :value="houseNumber"
          label="מס׳ בית"
          validations="required|numeric|max:20"
          @observe="observe"
          @input="setHouseNumber">
        </default-text-input>

        <default-text-input
          :value="apartment"
          label="דירה"
          validations="numeric|max:20"
          @observe="observe"
          @input="setApartmentValue">
        </default-text-input>
      </div>
    </div>
    <default-button label="הבא >" @click="nextPage" :disable="locked" :loading="locked"/>

  </div>

</template>

<script>
import _ from 'lodash';
import WizardPage from '@/mixins/WizardPage';
import { mapState, mapMutations, mapActions } from 'vuex';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';
import DefaultAutocomplete from '@/components/styled/DefaultAutocomplete';

export default {
  name: 'Address',
  components: { DefaultAutocomplete, DefaultTextInput, DefaultButton },
  mixins: [WizardPage],
  computed: {
    ...mapState('meitavDash/openFund', ['street', 'houseNumber', 'apartment', 'city']),
    ...mapState('cityAndStreet', ['cities', 'streets']),
  },
  methods: {
    ...mapMutations('meitavDash/openFund', ['setStreet', 'setHouseNumber', 'setApartment', 'setCity']),
    ...mapActions('cityAndStreet', ['setChosenCityForStreetsOptions']),
    async setAddressCity(city) {
      await this.setCity(city);
      await this.setChosenCityForStreetsOptions(city.label);
      this.$refs.street.focus();
    },
    setAddressStreet(street) {
      this.setStreet(street);
      this.$refs.houseNumber.focus();
    },
    setApartmentValue(apartment) {
      if (_.isNil(apartment)) {
        this.setApartment(undefined);
        return;
      }
      const trimmedApartment = _.trim(apartment);
      if (trimmedApartment.length === 0) {
        this.setApartment(undefined);
        return;
      }
      this.setApartment(trimmedApartment);
    },
  },
};
</script>
